var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "jumbotron d-flex justify-content-center align-items-center vh-100"
  }, [_c("div", {
    staticClass: "menu-wrapper"
  }, [_c("div", {
    staticClass: "row row-cols-2 row-cols-lg-3 g-4"
  }, _vm._l(_vm.menuItems, function (item, index) {
    return _c("MenuItem", {
      key: index,
      attrs: {
        path: item.path,
        icon: item.icon,
        altText: item.altText,
        caption: item.caption,
        iconColor: item.iconColor,
        hoverColor: item.hoverColor
      }
    });
  }), 1)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };